<template>
  <div>
    <NavBar />
    <!-- 申请结算页面 -->
    <div class="content-container">
      <div class="list-container">
        <div class="menu-title">
          申请结算
          <div style="float: right">
            <el-button type="primary" @click="paymentReported">提交申请</el-button>
            <el-button @click="back" style="margin-left: 10px">取消</el-button>
          </div>
        </div>
        <el-form>
          <el-card shadow="never" style="border: none">
            <div slot="header" style="font-weight: bold">结算数据</div>
            <div>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="prop" label="账单日期" label-width="100px">
                  <el-form-item slot-scope="scope">
                    <span>{{
                        emptyTrans(
                          scope.row[0].endTime
                            ? scope.row[0].startTime + "~" + scope.row[0].endTime
                            : scope.row[0].startTime + "至今"
                        )
                    }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column prop="prop" label="任务名称" label-width="100px">
                  <el-form-item slot-scope="scope">
                    <span>{{ emptyTrans(scope.row[0].productName) }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column prop="prop" label="单价/比例" label-width="100px">
                  <el-form-item slot-scope="scope">
                    <div v-for="items in scope.row">
                      <span>{{ moneyTrans(items.outPrice) }}</span>
                    </div>
                  </el-form-item>
                </el-table-column>
                <el-table-column prop="prop" label="结算数据" label-width="100px">
                  <el-form-item slot-scope="scope">
                    <span>{{
                        moneyTrans(scope.row[0].trafficUserApprovalDataNums)
                    }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column prop="prop" label="佣金(含税)" label-width="100px">
                  <el-form-item slot-scope="scope">
                    <span>{{
                        moneyTrans(scope.row[0].trafficUserApprovalMoney)
                    }}</span>
                  </el-form-item>
                </el-table-column>
              </el-table>
            </div>
            <div style="font-size: 14px; margin-top: 16px">
              <el-row>
                <el-col :span="12" class="see">
                  共计
                  <span>{{ emptyTrans(tableTotal) }}</span>
                  条
                </el-col>
                <el-col :span="12" style="text-align: right; float: right" min-width="250px">
                  <span class="see">合计:</span>&nbsp;佣金(含税)总额:
                  <span>{{ moneyTrans(commissionTotals) }}</span>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-form>
        <el-card shadow="never" style="border: none">
          <div slot="header">收款信息</div>
          <div>
            <el-form ref="form" :model="ruleForm" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="公司名称">
                    <el-select v-model="ruleForm.subjectName" @change="selectChange" filterable>
                      <el-option v-for="item in subjectList" :key="item.id" :label="item.subjectName" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="公司类型">
                    <span>{{
                        emptyTrans(subjectInfo.type == 1 ? "企业" : "个人")
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开票项目">
                    <el-select v-model="ruleForm.invoiceName" @change="selectChange" filterable>
                      <el-option v-for="item in invoiceList" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开票单位">
                    <span>{{ emptyTrans(subjectInfo.invoiceName) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="银行账号">
                    <span>{{ emptyTrans(subjectInfo.payBank) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="账户名称">
                    <span>{{ emptyTrans(subjectInfo.payee) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开户行">
                    <span>{{ emptyTrans(subjectInfo.openBankName) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="支行名称">
                    <span>{{ emptyTrans(subjectInfo.branchBank) }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
        <div>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="35%">
            <span>确认提交申请？</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleClose">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { getAduserInfo, applySettlement, getSettlementInfo } from "@/api/bill";
import {
  emptyTrans,
  formatMoney,
  formatDate,
  statusTrans,
  countCurrentPage,
  getDictList,
} from "@/api/dataTrans.js";
export default {
  components: {
    NavBar,
  },
  mounted() {
    this.intervalIds = this.$route.query.intervalIds;
    this.trafficUserId = this.$route.query.trafficUserId;
    this.entityList = getDictList(254);
    this.invoiceList = getDictList(212);
    this.getDetil();
    this.getAduser();
    if (this.invoiceList) {
      this.ruleForm.invoiceName = this.invoiceList[0].id;
    }
  },
  data() {
    return {
      tableData: [],
      tableTotal: null,
      billId: null,
      invoiceList: [],
      subjectList: [],
      form: [],
      ruleForm: {
        //   开票项目
        invoiceName: null,
        // 公司名称
        subjectName: null,
        payBank: null,
        payee: null,
        openBankName: null,
        branchBank: null,
      },
      commissionTotals: null,
      entityList: [],
      subjectInfo: {
        type: null,
        invoiceName: null,
      },
      dialogVisible: false,
      intervalIds: null,
      trafficUserId: null,
    };
  },
  methods: {
    back() {
      this.$router.push("/bill");
    },
    paymentReported(_val) {
      this.dialogVisible = true;
    },
    emptyTrans(_val) {
      return emptyTrans(_val);
    },
    moneyTrans(_val) {
      return formatMoney(_val);
    },
    // 列表转换
    trans(_val, _list) {
      return statusTrans(_val, _list).val;
    },
    // 获取详情
    getDetil() {
      const _this = this;
      if (this.intervalIds) {
        getSettlementInfo({ intervalIds: this.intervalIds }).then((res) => {
          if (res && res.code == 0) {
            _this.tableData = _this.transMediaData(
              res.data.jdTrafficIntervalDataVOList
            );
            _this.tableTotal = _this.tableData.length;
            _this.commissionTotals = res.data.amountApproval;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 区间数据转换
    transMediaData(_dataArr) {
      var _arr = _dataArr;
      let newData = {};
      _arr.forEach((e) => {
        //新建属性名
        if (Object.keys(newData).indexOf("" + e.intervalTag) === -1) {
          newData[e.intervalTag] = [];
        }
        newData[e.intervalTag].push(e);
      });
      var arrArr = [];
      Object.keys(newData).forEach((items) => {
        arrArr.push(newData[items]);
      });
      this.isArea = true;
      return arrArr;
    },
    // 获取流量主主体信息
    getAduser() {
      const _this = this;
      let token = localStorage.getItem("token");
      getAduserInfo({ access_token: token }).then((res) => {
        if (res && res.code == 0) {
          if (res.data.length == '0') {
            _this.$message.error("请完善公司信息后再次申请结算");
          } else {
            res.data.forEach((item) => {
              if (item.type == '1') {
                _this.subjectList.push(item);
              }
            });
            if (_this.subjectList[0]) {
              _this.subjectInfo = _this.subjectList[0];
              _this.ruleForm.subjectName = _this.subjectList[0].subjectName;
            } else {
              _this.$message.error("请在个人中心完善对公主体信息");
            }
          }
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    // 主体id转换
    idsTrans(_val) {
      const _this = this;
      var id = null;
      if (typeof _val == "string") {
        _this.subjectList.forEach((item) => {
          if (item.subjectName == _val) {
            id = item.id;
          }
        });
      } else {
        id = _val;
      }
      return id;
    },

    // 开票项目id转换
    // invoiceTrans(_val) {
    //   const _this = this;
    //   var id = null;
    //   _this.invoiceList.forEach((item) => {
    //     if (item.name == _val) {
    //       id = item.id;
    //     }
    //   });
    //   return id;
    // },
    // 区间id处理
    idTrans(_val) {
      var newArr = [];
      if (_val.length > 0 && _val.length == 1) {
        newArr.push(_val[0][0].intervalId);
      } else {
        _val.forEach((item) => {
          newArr.push(item[0].intervalId);
        });
      }
      return newArr;
    },

    //主体切换监听
    selectChange(val) {
      for (var i = 0; i < this.subjectList.length; i++) {
        if (this.subjectList[i].id == val) {
          this.subjectInfo = this.subjectList[i];
          this.subjectInfo.sujectId = this.subjectList[i].id;
        }
      }
    },
    handleClose() {
      const _this = this;
      let _obj = {
        subjectId: _this.idsTrans(_this.ruleForm.subjectName),
        invoiceContent: _this.ruleForm.invoiceName,
        approvalIntervalIds: _this.idTrans(_this.tableData),
      };
      applySettlement(_obj).then((res) => {
        if (res && res.code == 0) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.$router.push("/bill");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-form-item__label {
  text-align: left;
}

/deep/.el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

.icon {
  display: none;
  text-align: center;
}

/deep/.el-form-item__label {
  text-align: right;
}

.iconfont {
  display: none;
}

/deep/.el-form-item {
  width: 90%;
  margin-bottom: 16px;
}

.list-container {
  background-color: #fff;
  padding: 24px;
  margin-right: 24px;
  min-height: 860px;
}

.menu-title {
  height: 60px;
  line-height: 60px;
  width: 100%;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  padding-left: 24px;
  overflow: hidden;
  margin-bottom: 24px;
}

.space {
  text-align: right;
}

/deep/ .el-dialog__footer {
  border: none;
}

.see {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
}
</style>